import { render, staticRenderFns } from "./page-loader-container.vue?vue&type=template&id=1d5a3453&"
import script from "./page-loader-container.vue?vue&type=script&lang=js&"
export * from "./page-loader-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports